import { render, staticRenderFns } from "./RichiestaContatti.vue?vue&type=template&id=7331fd87"
import script from "./RichiestaContatti.vue?vue&type=script&lang=js"
export * from "./RichiestaContatti.vue?vue&type=script&lang=js"
import style0 from "./RichiestaContatti.vue?vue&type=style&index=0&id=7331fd87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports